import { Rect } from '../../drawing';
import { ChantContext } from '../../public-api';
import { ChantLayoutElement } from '../layout/ChantLayoutElement';

export class RectangleVisualizer extends ChantLayoutElement {
  constructor(context: ChantContext, bounds: Rect) {
    super(context);
    this.bounds = bounds;
  }

  public performLayout(...args: any[]): void {
  }

  public createSvgFragments(): SVGElement[] {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('x', String(this.bounds.x));
    rect.setAttribute('y', String(this.bounds.y));
    rect.setAttribute('width', String(this.bounds.width));
    rect.setAttribute('height', String(this.bounds.height));
    rect.setAttribute('fill', 'none');
    rect.setAttribute('stroke', 'red');
    rect.setAttribute('stroke-width', '1');

    return [
      ...super.createSvgFragments(),
      rect,
    ];
  }
}
